module.exports = __webpack_public_path__ + "img/photo1.d6bf310b.png";